import { Card, CardBody, Table, TabPane } from "reactstrap";
import { useTranslation } from "react-i18next";
import DefaultButton from "../../../../../components/Buttons/Default";
import CreateExpenseVendorModal from "../Modals/CreateExpenseVendor";
import { useState } from "react";
import IconButton from "../../../../../components/Buttons/IconButton";
import { IoCreateOutline } from "react-icons/io5";
import { BsTrash3 } from 'react-icons/bs';
import { del } from "../../../../../utils/helpers/api";
import ConfirmationModal from "../../../../../components/Modals/Confirmation";
import { toast } from "react-toastify";

function ExpenseVendors({ vendors, refreshVendors }) {
  const { t } = useTranslation();
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [vendorToDelete, setVendorToDelete] = useState(null);
  const [vendorToEdit, setVendorToEdit] = useState(null);


  const deleteVendor = async () => {
    const data = await del(`/accounting/expense-vendors/delete/${vendorToDelete}`);
    if(data?.success) {
      refreshVendors();
      setVendorToDelete(null);
      toast.success(t('accounting.vendorDeleted'));
    }
  }

  return(
    <TabPane tabId="expense-vendors">
      <Card>
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="text-muted small fw-semibold text-uppercase mb-0">
              {t('accounting.expenseVendors')}
            </p>
            <DefaultButton
              color="primary"
              size="sm"
              onClick={() => {
                setVendorToEdit(null);
                setCreateModalOpen(true);
              }}
            >
              + {t('accounting.newVendor')}
            </DefaultButton>
          </div>

          <Table hover responsive className="mb-0">
            <thead className="table-light">
              <tr>
                <th>{t('common.name')}</th>
                <th>{t('timeline.createdBy')}</th>
                <th>{t('common.actions')}</th>
              </tr>
            </thead>
            <tbody>
              {vendors?.map((data, key) => (
                <tr key={key}>
                  <td>{ data.name }</td>
                  <td>{ data.created_by?.firstname + ' ' + data.created_by?.lastname }</td>
                  <td>
                    <div className="d-flex align-items-center gap-2 h-100">
                      <IconButton
                        size="sm" 
                        outline 
                        color="secondary"
                        onClick={() => {
                          setVendorToEdit(data);
                          setCreateModalOpen(true);
                        }}
                      >
                        <IoCreateOutline />
                      </IconButton>
                      <IconButton
                        size="sm" 
                        outline 
                        color="danger"
                        onClick={() => setVendorToDelete(data.id)}
                      >
                        <BsTrash3 />
                      </IconButton>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>

      <CreateExpenseVendorModal 
        isOpen={createModalOpen}
        toggle={() => setCreateModalOpen(!createModalOpen)}
        onSave={() => refreshVendors()}
        vendorToEdit={vendorToEdit}
      />

      <ConfirmationModal
        isOpen={vendorToDelete !== null}
        title={t('accounting.deleteExpenseVendorTitle')}
        message={t('accounting.deleteExpenseVendorConfirm')}
        onConfirm={deleteVendor}
        toggle={() => setVendorToDelete(null)}
      />
    </TabPane>
  );
}

export default ExpenseVendors;